import React from "react";
import searchIcon from "../../assets/search.svg";
import passwordIcon from "../../assets/hide-pw.svg";
import addIcon from "../../assets/add.svg";
import skipIcon from "../../assets/skip.svg";
import previousIcon from "../../assets/previous.svg";
import teamsEmptyStateIcon from "../../assets/teams-empty-state.svg";
import closeIcon from "../../assets/close.svg";
import chatAvatar from "../../assets/chat-avatar.png";
import verticalEllipsisIcon from "../../assets/vertical-ellipsis.svg";
import attachmentIcon from "../../assets/attachment.svg";
import emojiIcon from "../../assets/smiley.svg";
import sendIcon from "../../assets/send.svg";
import showPasswordIcon from "../../assets/eye.svg";
import dragAndDropIcon from "../../assets/drag-drop.svg";
import dob from "../../assets/dob.svg";
// import settingsIcon from "../../assets/settings.svg";
// import modelIcon from "../../assets/models.svg";
// import teamsIcon from "../../assets/teams.svg";
// import faqIcon from "../../assets/faq.svg";
// import chatIcon from "../../assets/chat.svg";
// import logoutIcon from "../../assets/log-out.svg";
// import dashboardIcon from "../../assets/dashboard-outline.svg";
// import applicationsIcon from "../../assets/applications.svg";
import bvnIcon from "../../assets/bvn.svg";
import contactIcon from "../../assets/contact-number.svg";
import emailIcon from "../../assets/email.svg";
import locationIcon from "../../assets/location.svg";
import nationalIdIcon from "../../assets/national-id.svg";
import imageIcon from "../../assets/image.svg";
import fileIcon from "../../assets/file.svg";
import copyIcon from "../../assets/copy.svg";
import dropDownIcon from "../../assets/dropdown.svg";
import nextIcon from "../../assets/next-tab.svg";
import companyLogo from "../../assets/floralogo.png";
import dropAndDragIcon from "../../assets/settings-drag-drop.svg";
import profileAvatar from "../../assets/profile-avatar.png";
import pushNotificationOff from "../../assets/push-off.svg";
import pushNotificationOn from "../../assets/push-on.svg";
import chatAttachIcon from "../../assets/chat-attachment.svg";
import chatCameraIcon from "../../assets/chat-camera.svg";
import chatContactIcon from "../../assets/chat-contact.svg"
import chatDocumentIcon from "../../assets/chat-document.svg";
import chatGalleryIcon from "../../assets/chat-gallery.svg";
import chatLocationIcon from "../../assets/chat-location.svg";
import chatAudioIcon from "../../assets/chat-audio.svg";
import goodToastIcon from "../../assets/good-toast.svg";
import closeToastIcon from "../../assets/close-toast.svg";
import backIcon from "../../assets/back.svg";

// copy Icon
const CopyIcon = (props) => <img src={copyIcon} alt="copy Icon" {...props} />;

// Image Icon
const ImageIcon = (props) => <img src={imageIcon} alt="Img Icon" {...props} />;

// File Icon
const FileIcon = (props) => <img src={fileIcon} alt="File Icon" {...props} />;

// National ID Icon
const NationalIdIcon = (props) => (
  <img src={nationalIdIcon} alt="National ID Icon" {...props} />
);

// Search Icon
const SearchIcon = (props) => (
  <img src={searchIcon} alt="Search Icon" {...props} />
);

// Password Icon
const PasswordIcon = (props) => (
  <img src={passwordIcon} alt="Hide password Icon" {...props} />
);

// Skip Icon
const SkipIcon = (props) => <img src={skipIcon} alt="Skip Icon" {...props} />;

// Previous Icon
const PreviousIcon = (props) => (
  <img src={previousIcon} alt="Previous Icon" {...props} />
);

// Teams Empty State Icon
const TeamsEmptyStateIcon = (props) => (
  <img src={teamsEmptyStateIcon} alt="Empty-State Icon" {...props} />
);

// Close Icon
const CloseIcon = (props) => (
  <img src={closeIcon} alt="Close Icon" {...props} />
);

// Chat Avatar
const ChatAvatar = (props) => (
  <img src={chatAvatar} alt="chat avatar" {...props} />
);

// Vertical Ellipsis Icon
const VerticalEllipsisIcon = (props) => (
  <img src={verticalEllipsisIcon} alt="ellipsis" {...props} />
);

// Attachment Icon
const AttachmentIcon = (props) => {
  return <img src={attachmentIcon} alt="attachment icon" {...props} />;
};

// Emoji Icon
const EmojiIcon = (props) => {
  return <img src={emojiIcon} alt="emoji icon" {...props} />;
};

// Send Icon
const SendIcon = (props) => {
  return <img src={sendIcon} alt="send icon" {...props} />;
};

// Show-Password Icon
const ShowPasswordIcon = (props) => {
  return <img src={showPasswordIcon} alt="show password icon" {...props} />;
};

// Drag and drop Icon
const DragAndDropIcon = (props) => {
  return <img src={dragAndDropIcon} alt="send icon" {...props} />;
};

// Dob Icon
const DobIcon = (props) => <img src={dob} alt="send icon" {...props} />;

// Dashboard Icon
const DashboardIcon = ({ stroke = "currentColor", ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6C4 4.89543 4.89543 4 6 4H8C9.10457 4 10 4.89543 10 6V8C10 9.10457 9.10457 10 8 10H6C4.89543 10 4 9.10457 4 8V6Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 6C14 4.89543 14.8954 4 16 4H18C19.1046 4 20 4.89543 20 6V8C20 9.10457 19.1046 10 18 10H16C14.8954 10 14 9.10457 14 8V6Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 16C4 14.8954 4.89543 14 6 14H8C9.10457 14 10 14.8954 10 16V18C10 19.1046 9.10457 20 8 20H6C4.89543 20 4 19.1046 4 18V16Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 16C14 14.8954 14.8954 14 16 14H18C19.1046 14 20 14.8954 20 16V18C20 19.1046 19.1046 20 18 20H16C14.8954 20 14 19.1046 14 18V16Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Applications Icon
const ApplicationsIcon = ({ stroke = "currentColor", ...props }) => (
  <svg
    width="24"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 5V13C5 14.1046 5.89543 15 7 15H13M5 5V3C5 1.89543 5.89543 1 7 1H11.5858C11.851 1 12.1054 1.10536 12.2929 1.29289L16.7071 5.70711C16.8946 5.89464 17 6.149 17 6.41421V13C17 14.1046 16.1046 15 15 15H13M5 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H11C12.1046 19 13 18.1046 13 17V15"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Settings Icon
const SettingsIcon = ({ stroke = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M8.32463 2.31731C8.75103 0.560897 11.249 0.560897 11.6754 2.31731C11.9508 3.45193 13.2507 3.99038 14.2478 3.38285C15.7913 2.44239 17.5576 4.2087 16.6172 5.75218C16.0096 6.74925 16.5481 8.04918 17.6827 8.32463C19.4391 8.75103 19.4391 11.249 17.6827 11.6754C16.5481 11.9508 16.0096 13.2507 16.6172 14.2478C17.5576 15.7913 15.7913 17.5576 14.2478 16.6172C13.2507 16.0096 11.9508 16.5481 11.6754 17.6827C11.249 19.4391 8.75103 19.4391 8.32463 17.6827C8.04918 16.5481 6.74926 16.0096 5.75219 16.6172C4.2087 17.5576 2.44239 15.7913 3.38285 14.2478C3.99038 13.2507 3.45193 11.9508 2.31731 11.6754C0.560897 11.249 0.560897 8.75103 2.31731 8.32463C3.45193 8.04918 3.99037 6.74926 3.38285 5.75218C2.44239 4.2087 4.2087 2.44239 5.75219 3.38285C6.74926 3.99037 8.04918 3.45193 8.32463 2.31731Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 10C13 11.6569 11.6569 13 10 13C8.34315 13 7 11.6569 7 10C7 8.34315 8.34315 7 10 7C11.6569 7 13 8.34315 13 10Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Model Icon
const ModelIcon = ({ stroke = "currentColor", ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 7V17C4 19.2091 7.58172 21 12 21C16.4183 21 20 19.2091 20 17V7M4 7C4 9.20914 7.58172 11 12 11C16.4183 11 20 9.20914 20 7M4 7C4 4.79086 7.58172 3 12 3C16.4183 3 20 4.79086 20 7M20 12C20 14.2091 16.4183 16 12 16C7.58172 16 4 14.2091 4 12"
      stroke={stroke}
      strokeWidth="2"
    />
  </svg>
);

// Teams Icon
const TeamsIcon = ({ stroke = "currentColor", ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4.35418C12.7329 3.52375 13.8053 3 15 3C17.2091 3 19 4.79086 19 7C19 9.20914 17.2091 11 15 11C13.8053 11 12.7329 10.4762 12 9.64582M15 21H3V20C3 16.6863 5.68629 14 9 14C12.3137 14 15 16.6863 15 20V21ZM15 21H21V20C21 16.6863 18.3137 14 15 14C13.9071 14 12.8825 14.2922 12 14.8027M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Faq Icon
const FaqIcon = ({ stroke = "currentColor", ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.22766 9C8.77678 7.83481 10.2584 7 12.0001 7C14.2092 7 16.0001 8.34315 16.0001 10C16.0001 11.3994 14.7224 12.5751 12.9943 12.9066C12.4519 13.0106 12.0001 13.4477 12.0001 14M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Chat Icon
const ChatIcon = ({ stroke = "currentColor", ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12H8.01M12 12H12.01M16 12H16.01M21 12C21 16.4183 16.9706 20 12 20C10.4607 20 9.01172 19.6565 7.74467 19.0511L3 20L4.39499 16.28C3.51156 15.0423 3 13.5743 3 12C3 7.58172 7.02944 4 12 4C16.9706 4 21 7.58172 21 12Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Logout Icon
const LogoutIcon = ({ stroke = "currentColor", ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 16L7 12M7 12L11 8M7 12L21 12M16 16V17C16 18.6569 14.6569 20 13 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H13C14.6569 4 16 5.34315 16 7V8"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// / BVN Icon
const BvnIcon = (props) => <img src={bvnIcon} alt="BVN Icon" {...props} />;

// Contact Number Icon
const ContactIcon = (props) => (
  <img src={contactIcon} alt="Contact Number Icon" {...props} />
);

// Email Icon
const EmailIcon = (props) => (
  <img src={emailIcon} alt="Email Icon" {...props} />
);

// Location Icon
const LocationIcon = (props) => (
  <img src={locationIcon} alt="Location Icon" {...props} />
);

// Add Icon
const AddIcon = (props) => {return <img src={addIcon} alt="Add Icon" {...props} />;};

// Next-tab Icon
const NextIcon = (props) => <img src={nextIcon} alt="Next Icon" {...props} />;

// ompany Logo
const CompanyLogo = (props) => (<img src={companyLogo} alt="Company Logo" {...props} />);

// Drop & drag Icon
const DropAndDragIcon = (props) => (<img src={dropAndDragIcon} alt="Drop-drag Icon" {...props} />);

// Profile avatar
const ProfileAvatar = (props) => (<img src={profileAvatar} alt="Profile Avatar" {...props} />);

// Push notification off icon
const PushNotificationOff = (props) => (<img src={pushNotificationOff} alt=" Push-off Icon" {...props} />);

// Push notification on icon
const PushNotificationOn = (props) => (<img src={pushNotificationOn} alt="Push-on Icon" {...props} />);

// Dropdown Icon
const DropDownIcon = (props) => (<img src={dropDownIcon} alt="Drop-down Icon" {...props} />);

// Chat-attach Icon
const ChatAttachIcon = (props) => (<img src={chatAttachIcon} alt="Chat-attach Icon" {...props} />);

// Chat-camera Icon
const ChatCameraIcon = (props) => (<img src={chatCameraIcon} alt="Camera Icon" {...props} />);

// Chat-contact Icon
const ChatContactIcon = (props) => (<img src={chatContactIcon} alt="Chat-Contact Icon" {...props} />);

// Chat-document Icon
const ChatDocumentIcon = (props) => (<img src={chatDocumentIcon} alt="Chat-Document Icon" {...props} />);

// Chat-gallery Icon
const ChatGalleryIcon = (props) => (<img src={chatGalleryIcon} alt="Chat-Gallery Icon" {...props} />);

// Chat-location Icon
const ChatLocationIcon = (props) => (<img src={chatLocationIcon} alt="Chat-Location Icon" {...props} />);

// Chat-audio Icon
const ChatAudioIcon = (props) => (<img src={chatAudioIcon} alt="Chat-Audio Icon" {...props} />);

// Good-toast Icon
const GoodToastIcon = (props) => (<img src={goodToastIcon} alt="Good-Toast Icon" {...props} />);

// Close-toast Icon
const CloseToastIcon = (props) => (<img src={closeToastIcon} alt="Close-Toast Icon" {...props} />);

// Back Icon
const BackIcon = (props) => (<img src={backIcon} alt="back Icon" {...props} />);

export {
  SearchIcon,
  SkipIcon,
  PreviousIcon,
  PasswordIcon,
  TeamsEmptyStateIcon,
  CloseIcon,
  ChatAvatar,
  VerticalEllipsisIcon,
  AttachmentIcon,
  EmojiIcon,
  SendIcon,
  ShowPasswordIcon,
  DragAndDropIcon,
  DobIcon,
  DashboardIcon,
  ApplicationsIcon,
  SettingsIcon,
  ModelIcon,
  TeamsIcon,
  FaqIcon,
  ChatIcon,
  LogoutIcon,
  BvnIcon,
  ContactIcon,
  EmailIcon,
  LocationIcon,
  NationalIdIcon,
  AddIcon,
  ImageIcon,
  FileIcon,
  CopyIcon,
  DropDownIcon,
  NextIcon,
  CompanyLogo,
  DropAndDragIcon,
  ProfileAvatar,
  PushNotificationOff,
  PushNotificationOn,
  ChatAttachIcon,
  ChatCameraIcon,
  ChatContactIcon,
  ChatDocumentIcon,
  ChatGalleryIcon,
  ChatLocationIcon,
  ChatAudioIcon,
  GoodToastIcon,
  CloseToastIcon,
  BackIcon
};
